import React from 'react';
import UpdateAppContainer from './../containers/UpdateAppContainer';

export default function AppUpdateLandingPres(props) {
  return <UpdateAppContainer {...props} />;
}
